import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

/**
 * This guard redirects to a specified path, if target url is attempted
 * the route that references it
 */
export class RedirectWithQueryParamGuard implements CanActivate {
  constructor(private router: Router) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const queryParam = next.queryParams[next.data.queryParamName];
    const redirectPathSegment = next.data.redirectPathSegment;
    this.router.navigate([redirectPathSegment, queryParam]);
    return false;
  }
}
